const accordions = document.querySelectorAll(".js-accordion");
[...accordions].forEach((accordion) => {
    accordion.addEventListener("click", function (event) {
        const accordion = event.currentTarget;
        const target = event.target;

        if (!target.matches("summary") || !target.closest("summary")) {
            return;
        }

        const parentDetails = target.closest("details");

        if (parentDetails.open) {
            parentDetails.open = !parentDetails.open;
            event.preventDefault();
            return;
        }

        accordion.querySelectorAll("details").forEach(function (details) {
            if (details !== parentDetails && details.open) {
                details.open = false;
            }
        });
        // Scroll to the current target
        parentDetails.scrollIntoView({
            behavior: "smooth",
            block: "start",
        });
    });
});

document.addEventListener("alpine:init", () => {
    Alpine.data("openTab", () => ({
        selectedId: null,
        selectedChildIndex: 0,
        previousChildIndex: null,
        get children() {
            return this.$refs.tablist.children;
        },
        init() {
            this.$nextTick(() => this.select(this.$refs.tablist.firstChild, this.$id("tab", 1)));
            this.length = this.children.length - 1;
        },
        select(el, id) {
            if (this.selectedId === id) return;
            [...this.children].forEach((tab) => tab.setAttribute("tabindex", "-1"));
            el.setAttribute("tabindex", "0");
            this.previousChildIndex = this.selectedChildIndex;
            this.selectedChildIndex = this.whichChild(el, this.$refs.tablist);
            this.moveIndicator();
        },
        keySelect(e) {
            // Move right
            if (["ArrowRight", "ArrowDown", "ArrowUp", "ArrowLeft"].includes(e.key)) {
                this.previousChildIndex = this.selectedChildIndex;
                this.children[this.selectedChildIndex]?.setAttribute("tabindex", -1);
                if (["ArrowRight", "ArrowDown"].includes(e.key)) {
                    this.selectedChildIndex = (this.selectedChildIndex + 1) % this.length;
                    if (this.selectedChildIndex === 0) {
                        this.previousChildIndex = -1;
                    }
                } else if (["ArrowUp", "ArrowLeft"].includes(e.key)) {
                    this.selectedChildIndex = (this.length + this.selectedChildIndex - 1) % this.length;
                    if (this.selectedChildIndex === this.length) {
                        this.previousChildIndex = this.length + 1;
                    }
                }

                this.children[this.selectedChildIndex]?.setAttribute("tabindex", 0);
                this.children[this.selectedChildIndex]?.focus();
                this.moveIndicator();
            }
        },
        moveIndicator() {
            const el = this.children[this.selectedChildIndex];
            if (el) {
                this.$refs.indicator.style.top = el.offsetTop + "px";
                this.$refs.indicator.style.height = el.offsetHeight + "px";
            }
        },
        isSelected(id) {
            return this.selectedId === id;
        },
        whichChild(el, parent) {
            return Array.from(parent.children).indexOf(el);
        },
    }));
});
